<template lang="html">
  <div class="section">
    <div class="Slide">
      <section>
        <div class="container">
          <div class="content">
            <header>
              <p><img src="../assets/images/top/img_club-header.svg" alt="放課後児童クラブ"></p>
              <h2>子どもたちが安心して<br class="visible-sp">安全に安定して過ごせる場所作り</h2>
            </header>
            <div class="Main">
              <div><img src="../assets/images/top/img_club.png" alt=""></div>
              <p><span>育成目標</span><br>
                「子どもたちが安心して安全に安定して過ごせる場所作り」<br>
                〇昼間の兄弟姉妹としてそれぞれの気持ちに寄り添い、優しい気持ちを持ちます。<br>
                〇正しい言葉で話します。（言葉で相手を傷つけない）<br>
                〇生活や遊びのルールを守ります。（人に迷惑をかけない）<br>
                〇自分の役割を果たします。（責任をもって行動する）
              </p>
            </div>
            <p class="note">少子化が進む昨今、家庭では経験出来ない異年齢集団の生活の中で、お互いの個性を認め合いながら、年齢に即した様々な活動を行っています。<br>
            その中で子ども達各々の成長段階を見極めながら、心の成長と社会性の育ちを見守っています。</p>
          </div>
        </div>
        <div class="footerContent">
          <ul>
            <li>
              <section>
                <img src="../assets/images/top/img_clubfooter001.png" alt="">
                <h3>第1代っチ</h3>
                <p>住所：石川県加賀市山代温泉山背台2-44-1(山代小学校内)<br>
                TEL・FAX：0761－76－4601</p>
              </section>
            </li>
            <li>
              <section>
                <img src="../assets/images/top/img_clubfooter002.png" alt="">
                <h3>第2代っチ</h3>
                <p>住所：石川県加賀市山代温泉山背台2-44-1(山代小学校内)<br>
                  TEL・FAX：0761－76－4601</p>
              </section>
            </li>
            <li>
              <section>
                <img src="../assets/images/top/img_clubfooter003.png" alt="">
                <h3>第3代っチ</h3>
                <p>住所：石川県加賀市山代温泉北部1-233<br>
                  TEL・FAX：0761-76-1126</p>
              </section>
            </li>
            <li>
              <section>
                <img src="../assets/images/top/img_clubfooter004.png" alt="">
                <h3>丘の子学童</h3>
                <p>住所：石川県加賀市下河崎町79-2<br>
                  TEL・FAX：0761-72-2204</p>
              </section>
            </li>
          </ul>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
  import $ from 'jquery';
  import 'slick-carousel';

  export default {
    name: 'ClubSlide',

    created() {
      this.initSlick();
    },

    methods: {
      initSlick() {
        $(() => {
          $('.footerContent ul').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding: '15px',
            arrows: false,
            dots: true,
            mobileFirst: true,
            responsive: [{
              breakpoint: 767,
              settings: {
                slidesToShow: 2,
                centerMode: false,
              },
            },
            {
              breakpoint: 1023,
              settings: 'unslick',
            }],
          });
        });
      },
    },
  };
</script>

<style lang="scss" src="slick-carousel/slick/slick.scss"></style>
<style lang="scss" src="slick-carousel/slick/slick-theme.scss"></style>
<style lang="scss" scoped>
@import '../assets/stylesheets/_mixin.scss';
.Slide {
  padding: 4rem 15px 0;
  position: relative;
  background: #ffc899 url("../assets/images/top/bg_club.png") right -12px top -77px no-repeat fixed;
  @include media( md ) {
    width: 100vw;
    height: 100vh;
    padding: 0;
  }
}
header {
  margin-bottom: 1.0rem;
  text-align: center;
  p {
    margin: 0;
    padding: 0;
    line-height: 0;
    img {
      text-align: center;
    }
  }
  @include media( md ) {
    display: flex;
    align-items: center;
    margin-bottom: 0;
    padding-top: 15px;
    text-align: left;
    p {
      img {
        margin: 0 3.5rem 0 0;
      }
    }
  }
}
h2 {
  font-size: 1.7rem;
  line-height: 1.35;
  @include media( md ) {
    font-size: 3.0rem;
  }
}
.container {
  display: flex;
  justify-content: center;
  align-items: center;
}
.content {
  @include media( md ) {
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 1000px;
    height: calc( 100vh - 270px );
  }
}

.Main {
  @include MarugoBold;
  margin-top: 2rem;
  p {
    font-size: 1.4rem;
    line-height: 1.63;
  }
  div {
    text-align: center;
  }
  @include media( sm ) {
    img {
      margin-right: 3em;
    }
    p {
      font-size: 1.85rem;
    }
    span {
      display: inline-block;
      font-size: 1.3em;
      margin-bottom: .5em;;
    }
  }
  @include media( md ) {
    display: flex;
    align-items: center;
  }
}

.note {
    font-size: 1.3rem;
    line-height: 2;
    @include media( sm ) {
      font-size: 1.5rem;
    }
}
.footerContent {
  margin: 0 -15px 0;
  padding-bottom: 40px;
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAIAAAACCAYAAABytg0kAAAAGElEQVQYV2P8/+X1fwYGBgZGEOPytZsMAFy0Cj+RV5HWAAAAAElFTkSuQmCC) repeat;
  @include media( md ) {
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    margin: 0;
  }
  h3 {
    margin-bottom: 1em;
    font-size: 1.6rem;
    line-height: 1;
  }
  ul {
    margin: 0;
    padding: 20px 0 0;
    @include media( sm ) {
      margin: 0;
      padding-bottom: 0;
    }
    @include media( md ) {
      display: flex;
      max-width: 1000px;
    }
  }
  li {
    p {
      font-size: 1.2rem;
      line-height: 1.5;
    }
    @include media( sm ) {
      width: calc( 100% / 2 );
      margin: 0 10px;
    }
    @include media( md ) {
      width: calc( 100% / 4 );
    }
  }
  section {
    width: 230px;
    margin: 0 auto;
  }
}
</style>



// WEBPACK FOOTER //
// ClubSlide.vue?1fc5da72